// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/**
 * The editor tracker token.
 */
export const ITerminalTracker = new Token('@jupyterlab/terminal:ITerminalTracker', `A widget tracker for terminals.
  Use this if you want to be able to iterate over and interact with terminals
  created by the application.`);
/**
 * The namespace for terminals. Separated from the widget so it can be lazy
 * loaded.
 */
export var ITerminal;
(function (ITerminal) {
    /**
     * The default options used for creating terminals.
     */
    ITerminal.defaultOptions = {
        theme: 'inherit',
        fontFamily: 'Menlo, Consolas, "DejaVu Sans Mono", monospace',
        fontSize: 13,
        lineHeight: 1.0,
        scrollback: 1000,
        shutdownOnClose: false,
        closeOnExit: true,
        cursorBlink: true,
        initialCommand: '',
        screenReaderMode: false, // False by default, can cause scrollbar mouse interaction issues.
        pasteWithCtrlV: true,
        autoFit: true,
        macOptionIsMeta: false
    };
})(ITerminal || (ITerminal = {}));
//# sourceMappingURL=tokens.js.map